/* tslint:disable */
import {
  CompanyAccount
} from '../index';

declare var Object: any;
export interface ManagementFeeSettingsInterface {
  "property_id": number;
  "flat_fee_existing"?: number;
  "percentage_existing"?: number;
  "flat_fee_new"?: number;
  "percentage_new"?: number;
  "management_company_id": number;
  "management_fee_expense_account": number;
  "excluded_income_accounts"?: string;
  "non_commisionable_income_accounts"?: string;
  "tenant_deposits"?: string;
  "id"?: number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt"?: Date;
  managementCompany?: CompanyAccount;
}

export class ManagementFeeSettings implements ManagementFeeSettingsInterface {
  "property_id": number;
  "flat_fee_existing": number;
  "percentage_existing": number;
  "flat_fee_new": number;
  "percentage_new": number;
  "management_company_id": number;
  "management_fee_expense_account": number;
  "excluded_income_accounts": string;
  "non_commisionable_income_accounts": string;
  "tenant_deposits": string;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt": Date;
  managementCompany: CompanyAccount;
  constructor(data?: ManagementFeeSettingsInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ManagementFeeSettings`.
   */
  public static getModelName() {
    return "ManagementFeeSettings";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ManagementFeeSettings for dynamic purposes.
  **/
  public static factory(data: ManagementFeeSettingsInterface): ManagementFeeSettings{
    return new ManagementFeeSettings(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ManagementFeeSettings',
      plural: 'ManagementFeeSettings',
      path: 'ManagementFeeSettings',
      idName: 'id',
      properties: {
        "property_id": {
          name: 'property_id',
          type: 'number',
          default: -1
        },
        "flat_fee_existing": {
          name: 'flat_fee_existing',
          type: 'number'
        },
        "percentage_existing": {
          name: 'percentage_existing',
          type: 'number'
        },
        "flat_fee_new": {
          name: 'flat_fee_new',
          type: 'number'
        },
        "percentage_new": {
          name: 'percentage_new',
          type: 'number'
        },
        "management_company_id": {
          name: 'management_company_id',
          type: 'number'
        },
        "management_fee_expense_account": {
          name: 'management_fee_expense_account',
          type: 'number'
        },
        "excluded_income_accounts": {
          name: 'excluded_income_accounts',
          type: 'string'
        },
        "non_commisionable_income_accounts": {
          name: 'non_commisionable_income_accounts',
          type: 'string'
        },
        "tenant_deposits": {
          name: 'tenant_deposits',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "deletedAt": {
          name: 'deletedAt',
          type: 'Date',
          default: new Date(0)
        },
      },
      relations: {
        managementCompany: {
          name: 'managementCompany',
          type: 'CompanyAccount',
          model: 'CompanyAccount',
          relationType: 'belongsTo',
                  keyFrom: 'management_company_id',
          keyTo: 'id'
        },
      }
    }
  }
}
